import { Head } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminEmailsIndex } from '@/types';
import { EmailFilters } from './components/EmailFilters';
import { EmailStatsCards } from './components/EmailStatsCards';
import { EmailTable } from './components/EmailTable';

export default function Index({
  emails,
  stats,
  pagination,
  filters,
  title,
}: AdminEmailsIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div>
          <h1 className="font-bold text-3xl tracking-tight">Email Management</h1>
          <p className="text-muted-foreground">
            View and manage all outbound emails
          </p>
        </div>

        <EmailStatsCards stats={stats} />

        <Card>
          <CardHeader>
            <CardTitle>Filters</CardTitle>
          </CardHeader>
          <CardContent>
            <EmailFilters initialParams={filters} />
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-0">
            <EmailTable emails={emails} pagination={pagination} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
